export default __webpack_public_path__ + "static/media/notConfirmed.d1643ee7.svg";